module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAp0lEQVQ4T+2T0Q3CIBRFTyeo3cARHKEb2H8/dIS6ASN0BEfQDRyhI9jEQcxNgDSUUgm/fQkh4d13HuFdKgqjitQfgesGdwRe0sQASj43AC0wSBcDvAEJUmFs0swBJ6BOVE3AxxWGgBugpe5roVtJI8jiBv4gAZBGDbR2QMEbfIEL0ACdJuJ8kDsFPywH6IHzHz64A7L6AnCwJtG+FjLQI0zG/kLWB/8BAUYuEVELijQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/最小化.png
// module id = K1/o
// module chunks = 1